import { DollarSign } from "@tamagui/lucide-icons";
import { Circle, LoadingButton, Paragraph, Subheadline3, YStack } from "@medbillai/ui";
import { useRouter } from "@medbillai/navigation/router";
import { Flag } from "@medbillai/utils";
import { accountsUrl, coverageUrl } from "@medbillai/utils/urls";
import { analyticsService } from "../../../../lib/analytics";
import { useBoolVariation } from "../../../../lib/flag";
import { filterOptionIds } from "../../utils/utils";
interface EmptyConnectedBlockProps {
  selectedFilter: string;
}
interface EmptyConnectedTextContent {
  title: string;
}
export const EmptyConnectedText = (selectFilter: string): EmptyConnectedTextContent => {
  switch (selectFilter) {
    case filterOptionIds.denied:
      return {
        title: "No denied bills with this \n insurance?"
      };
    case filterOptionIds.inNetwork:
      return {
        title: "No in-network bills with \n this insurance"
      };
    case filterOptionIds.outOfNetwork:
      return {
        title: "No out-of-network bills \n with this insurance"
      };
    case filterOptionIds.flagged:
      return {
        title: "No flagged bills"
      };
    default:
      return {
        title: "No bills with this \n insurance"
      };
  }
};
export const EmptyConnectedBlock = ({
  selectedFilter
}: EmptyConnectedBlockProps) => {
  const {
    push
  } = useRouter();
  const coverageTab = useBoolVariation(Flag.COVERAGE_TAB, false);
  const onPress = () => {
    analyticsService.trackEvent("InsuranceLinkingStarted", {
      source: "bill_empty_connected_block"
    });
    push(coverageTab ? coverageUrl() : accountsUrl());
  };
  const {
    title
  } = EmptyConnectedText(selectedFilter);
  const isFlagged = selectedFilter === filterOptionIds.flagged;
  return <YStack alignItems="center" justifyContent="flex-start" gap="$2" $platform-web={{
    maxWidth: 400,
    mx: "$5"
  }} data-sentry-element="YStack" data-sentry-component="EmptyConnectedBlock" data-sentry-source-file="EmptyConnectedBlock.tsx">
      <YStack alignItems="center" data-sentry-element="YStack" data-sentry-source-file="EmptyConnectedBlock.tsx">
        <Circle size="$8" backgroundColor="$surface0" zIndex={2} justifyContent="center" alignItems="center" data-sentry-element="Circle" data-sentry-source-file="EmptyConnectedBlock.tsx">
          <DollarSign size={36} strokeWidth={2} color="$iconDefault" data-sentry-element="DollarSign" data-sentry-source-file="EmptyConnectedBlock.tsx" />
        </Circle>
      </YStack>
      <Subheadline3 numberOfLines={2} pt="$2" textAlign="center" data-sentry-element="Subheadline3" data-sentry-source-file="EmptyConnectedBlock.tsx">
        {title}
      </Subheadline3>
      {!isFlagged ? <>
          <Paragraph theme="alt1" px="$8" textAlign="center">
            Connect another insurance?
          </Paragraph>
          <LoadingButton onPress={onPress} width="$12" mt="$4" height="$4">
            New Insurance
          </LoadingButton>
        </> : null}
    </YStack>;
};